export const RaceEntryStatus = {
  BOOKED: 'BOOKED',
  REFUNDED: 'REFUNDED',
  CANCELLED: 'CANCELLED',
  POSTPONED: 'POSTPONED',
  USER_GENERATED: 'USER_GENERATED',
};

export const RaceEntryStatuses = [
  RaceEntryStatus.BOOKED,
  RaceEntryStatus.REFUNDED,
  RaceEntryStatus.CANCELLED,
  RaceEntryStatus.POSTPONED,
  RaceEntryStatus.USER_GENERATED,
];

export const EligibleRaceEntryStatuses = [
  RaceEntryStatus.BOOKED,
  RaceEntryStatus.USER_GENERATED,
];

export const RaceEntryEventType = {
  REAL: 'REAL',
  VIRTUAL: 'VIRTUAL',
};

export const RaceEntryBookingType = {
  LDT: 'LDT',
  EXTERNAL: 'EXTERNAL',
};
